import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { ClassApiResponse, ClassListResponse } from "../../types/classesTypes";
import classesApis from "../../api/classesApis";
import { ThunkConfig } from "../../types/responseType";

interface ClassState {
  classes: ClassApiResponse[];
  isLoading: boolean;
  error: string | null;
  filters: Record<string, string>;
  page: number;
  size: number;
  total: number;
}

const initialState: ClassState = {
  classes: [],
  isLoading: false,
  error: null,
  filters: {},
  page: 0,
  size: 40,
  total: 0,
};

// fetching class list
export const fetchClasses = createAsyncThunk<
  ClassListResponse,
  {
    page?: number;
    size?: number;
    filters?: Record<string, string>;
    branchCode?: string;
  },
  ThunkConfig
>(
  "classes/fetchClasses",
  async (
    { page = 0, size = 10, filters = {}, branchCode },
    { rejectWithValue },
  ) => {

    const queryKey = JSON.stringify({
      page,
      size,
      filters,
      branchCode,
    });

    try {
      const res = await classesApis.fetchClass({
        page,
        size,
        ...filters,
        branchCode,
      });

      return {
        ...res!.data,
        _queryKey: queryKey,
      } as any;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  },
);

const classSlice = createSlice({
  name: "classes",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Record<string, string>>) => {
      state.filters = action.payload;
    },
    resetClasses: (state) => {
      state.classes = [];
      state.error = null;
      state.page = 0;
      state.total = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClasses.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchClasses.fulfilled, (state, action) => {
        state.isLoading = false;
        state.classes = action.payload.content;
        state.total = action.payload.totalElements;
        state.page = action.payload.number;
        state.size = action.payload.size;

      })

      .addCase(fetchClasses.rejected, (state, action) => {
        state.isLoading = false;

        state.error = action.payload as string;
      });
  },
});

export const { setFilters, resetClasses } = classSlice.actions;
export default classSlice.reducer;
